import {
  FESTIVE_DAYS_LOADING,
  FESTIVE_DAYS_ERROR,
  FESTIVE_DAYS_ADD,
  FESTIVE_DAYS_UPDATE,
  FESTIVE_DAYS_DELETE,
  // BIKE_SCAN_TRIGGER_COUNT,
  FESTIVE_DAYS_FILTERS,
  // FESTIVE_DAYS_FILTERS_V2,
  // BIKE_SCAN_TRIGGER_LIST,
  FESTIVE_DAYS_SEARCH,
  FESTIVE_DAYS_SINGLE,
  FESTIVE_DAYS_TYPES
} from "actions/festive-days/constants";

const initialState = {
  loading: false,
  errors: [],

  types: [],
  list: {},
  filters: [],
  single: {}
};

export default function (state = initialState, action) {
  let list = [],
    index;

  switch (action.type) {
    case FESTIVE_DAYS_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case FESTIVE_DAYS_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };

    case FESTIVE_DAYS_ADD:
      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      list.content.push(action.payload);
      return {
        ...state,
        loading: false,
        list
      };
    case FESTIVE_DAYS_UPDATE:
      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      index = list.content.findIndex(item => item.id === action.payload.id);
      if (index > -1) {
        list.content[index] = action.payload;
      } else {
        list.content.push(action.payload);
      }
      return {
        ...state,
        loading: false,
        list
      };
    case FESTIVE_DAYS_DELETE:
      list = Object.assign({}, state.list);
      list.content = Object.assign([], list.content);
      index = list.content.findIndex(item => item.id === action.payload);
      if (index > -1) {
        list.content.splice(index, 1);
      }
      return {
        ...state,
        loading: false,
        list
      };
    case FESTIVE_DAYS_FILTERS:
      return {
        ...state,
        filters: action.payload
      };
    case FESTIVE_DAYS_SEARCH:
      return {
        ...state,
        loading: false,
        list: action.payload
      };
    case FESTIVE_DAYS_SINGLE:
      return {
        ...state,
        loading: false,
        single: Array.isArray(action.payload.content) && action.payload.content[0]
          ? action.payload.content[0]
          : {}
      };
    case FESTIVE_DAYS_TYPES:
      return {
        ...state,
        types: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/festiveDaysReducer.js